export const sortDepletedProductsLast = (products = []) => {
    const availabilityPriority = (product) => {
        if (product?.availabilityState === 'AVAILABLE') return 0;
        if (product?.availabilityState === 'RESERVABLE') return 1;
        if (['SOLD_OUT', 'UNAVAILABLE'].includes(product?.availabilityState)) return 2;
        if ((product?.quantity ?? 0) > 0) return 0;
        return product?.deliveryMode === 'reservable' ? 1 : 2;
    };

    return products
        .map((product, index) => ({ product, index }))
        .sort((left, right) => (
            availabilityPriority(left.product) - availabilityPriority(right.product)
            || left.index - right.index
        ))
        .map(({ product }) => product);
};

export const sortUnavailableCombosLast = (combos = []) => {
    return [...combos].sort((a, b) => {
        const aUnavailable = ['SOLD_OUT', 'UNAVAILABLE'].includes(a?.availabilityState) || a?.available !== true ? 1 : 0;
        const bUnavailable = ['SOLD_OUT', 'UNAVAILABLE'].includes(b?.availabilityState) || b?.available !== true ? 1 : 0;
        return aUnavailable - bUnavailable;
    });
};
